import EntityApi from "../../../api/EntityApi";
import React from "react";
import {Button, message, Progress} from 'antd';
import {ArrowIcon, CheckedCircleIcon} from "../../../assets/icons";

var intervalId = 0;

const ExamTesting = ({materialId, onClose, onStart}) => {

    const [contentHeight, setContentHeight] = React.useState('0px');
    const [loading, setLoading] = React.useState(false);
    const [testingId, setTestingId] = React.useState(null);
    const [testingName, setTestingName] = React.useState('');
    const [testingDescription, setTestingDescription] = React.useState('');

    const [step, setStep] = React.useState(0);
    const [prevStep, setPrevStep] = React.useState(0);
    const [nextStep, setNextStep] = React.useState(1);
    const [isFinish, setFinish] = React.useState(false);
    const [dataItem, setDataItem] = React.useState(null);
    const [timerInterval, setTimerInterval] = React.useState(null);
    const [timer, setTimer] = React.useState('');
    const [progressTimer, setProgressTimer] = React.useState(0);
    const [progress, setProgress] = React.useState(0);
    const [userAnswers, setUserAnswers] = React.useState([]);
    const [isAnswersMultiple, setAnswersMultiple] = React.useState(false);
    const [isContinue, setContinue] = React.useState(false);
    //const [timestamps, setTimestamps] = React.useState([]);

    //const [questions, setQuestions] = React.useState([]);
    // Finish Show Result
    const [resultFinish, setResultFinish] = React.useState(null);

    const setTimestamps = (id, type) => {
        let key = 'timestamps';
        if (!localStorage.getItem(key)) {
            localStorage.setItem(key, JSON.stringify([]));
        }
        let tms = JSON.parse(localStorage.getItem(key));
        if (type === 'start') {
            tms.push({
                id: id,
                start: new Date().getTime()
            });
        }
        if (type === 'end') {
            tms.push({
                id: id,
                end: new Date().getTime()
            });
        }
        localStorage.setItem(key, JSON.stringify(tms));
    }

    const clearTimestamps = () => {
        let key = 'timestamps';
        localStorage.setItem(key, JSON.stringify([]));
    }

    const onStep = (step) => {

        setStep(step);
        setLoading(true);
        // пытаемся получить следующий шаг и получить инфу о тестировании
        EntityApi.post('private/exam/step', testingId, {
            step: step
        }).then((data) => {
            setLoading(false);
            if (data.status === EntityApi.STATUS_SUCCESS && data.content.item !== undefined) {

                if (data.content.item.protected_limit !== undefined && data.content.item.protected_limit) {
                    message.error('У вас закончилось количество попыток: ' + data.content.item.limit);
                    onClose();
                    return;
                }

                onStart(true)

                console.log(data);
                let item = data.content.item;

                // Запишем метку времени начала вопроса
                if (item.question !== undefined) {
                    setTimestamps(item.question.id, 'start');
                }

                if (item.is_finished) {
                    onFinish();
                    return;
                }

                setStep(item.step_current);
                setDataItem(item);
                setAnswersMultiple(item.question.is_multiple);

                if (item.time_left > 0) {
                    const interval = startTimer(item.time_left, item.time);
                    //console.log(interval);
                    //setTimerInterval(interval);
                    //console.log(timerInterval);
                    clearInterval(intervalId);
                    intervalId = interval;
                }
                if (item.progress > 0) {
                    setProgress(item.progress);
                }


                //setQuestions(item.questions);
            }
        }).catch((error) => {
            setLoading(false);
            console.log(error);
            message.error('Ошибка получения данных: step');
        });

    }

    const onClearStep = () => {
        setStep(0);
        setPrevStep(0);
        setNextStep(1);
        setDataItem(null);
        setProgress(0);
        setUserAnswers([]);
        setAnswersMultiple(false);
    }

    const onFinish = () => {
        onStart(true)
        setFinish(true);
        console.log(intervalId);
        clearInterval(intervalId);
        //setTimerInterval(null);
        intervalId = 0;
        setTimer('');
        setProgressTimer(0);
        onClearStep();
        setLoading(true);
        EntityApi.post('private/exam/finish', testingId, {

        }).then((data) => {
            setLoading(false);
            clearTimestamps();
            if (data.status === EntityApi.STATUS_SUCCESS && data.content.item !== undefined) {
                setResultFinish(data.content.item);
            }

        }).catch((error) => {
            setLoading(false);
            console.log(error);
            message.error('Ошибка получения данных: finish');
        });
    }

    const onClickAnswer = (id) => {

        if (!isAnswersMultiple) {
            setUserAnswers([id]);
            return;
        }

        const ids = userAnswers;
        const index = ids.indexOf(id);
        if (index > -1) {
            ids.splice(index, 1);
        } else {
            ids.push(id);
        }
        const uniqueIds = new Set(ids);
        setUserAnswers(Array.from(uniqueIds));
    }

    const onSelectStep = (id) =>
    {
        onClearStep();

        // Запишем метку времени конца вопроса
        if (dataItem) {
            setTimestamps(dataItem.question.id, 'end');
            console.log(localStorage.getItem('timestamps'));
        }

        onStep(id);
    }

    const onConfirmStep = (id) =>
    {

        if (userAnswers.length <= 0) {
            message.error('Пожалуйста, выберите варианты ответов');
            return;
        }

        setLoading(true);

        // Запишем метку времени конца вопроса
        if (dataItem) {
            setTimestamps(dataItem.question.id, 'end');
            console.log(localStorage.getItem('timestamps'));
        }

        EntityApi.post('private/exam/answer', testingId, {
            values: userAnswers,
            timestamps: localStorage.getItem('timestamps') ? JSON.parse(localStorage.getItem('timestamps')) : []
        }).then((data) => {
            onClearStep();
            setLoading(false);
            if (data.status === EntityApi.STATUS_SUCCESS) {
                onStep(id);
            }

        }).catch((error) => {
            setLoading(false);
            console.log(error);
            message.error('Ошибка получения данных: confirm');
        });

    }

    const startTimer = (totalSeconds, total) => {
        // Преобразуем минуты в миллисекунды
        let totalMilliseconds = totalSeconds  * 1000;
        let totalMs = total * 1000;
        const formatNumber = (number) => number < 10 ? `0${number}` : number;

        // Функция обновления отображения
        function updateDisplay() {
            const hours = Math.floor(totalMilliseconds / (1000 * 60 * 60));
            const minutes = Math.floor((totalMilliseconds % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((totalMilliseconds % (1000 * 60)) / 1000);
            let displayText = '';
            if (hours > 0) {
                displayText += `${formatNumber(hours)}:`;
            }
            displayText += `${formatNumber(minutes)}:${formatNumber(seconds)}`;

            setTimer(displayText);

            setProgressTimer(100 - Math.ceil(totalMilliseconds * 100 / totalMs));

            totalMilliseconds -= 1000;

            console.log('tick');

            // Проверяем, не закончилось ли время
            if (totalMilliseconds < 0) {
                onFinish();
                return;
            }
        }

        updateDisplay();
        return setInterval(updateDisplay, 1000);
    }

    React.useEffect(() => {

        let height = window.innerHeight * 0.45;
        setContentHeight(height + 'px');

    }, []);

    React.useEffect(() => {

        console.log('useEffectChangeMaterial');
        setDataItem(null);
        setTestingName('');
        setTestingDescription('');
        setStep(0);
        setPrevStep(0);
        setNextStep(1);
        onStart(false)
        setFinish(false);
        clearInterval(intervalId);
        intervalId = 0;
        setLoading(false);

        console.log('effect ' + materialId);

        if (materialId > 0) {
            setLoading(true);
            EntityApi.getBy('private/testing', {
                filter: {
                    material: materialId
                }
            }).then((data) => {
                setLoading(false);
                if (data.status === EntityApi.STATUS_SUCCESS && data.content.items !== undefined && data.content.items) {
                    data.content.items.forEach((item) => {
                        setTestingId(item.id);
                        setTestingName(item.name);
                        setTestingDescription(item.description);
                        setContinue(item.is_continue);
                        /*item.questions.forEach((question, index) => {
                            if (index === 0) {
                                setNextStep(question.id);
                            }
                        })*/
                    });
                }
            }).catch(() => {
                setLoading(false);
            });
        } else {
            console.log('clear ' + materialId);
        }

    }, [materialId])

    return <div className={'exam-testing'}>
    {
        loading &&
        <div style={{top: '0px', left: '0px'}} className="app-preloader absolute opacity-50 z-50 grid h-full w-full place-content-center bg-slate-50 dark:bg-navy-900">
            <div className="app-preloader-inner relative inline-block h-48 w-48"></div>
        </div>
    }
    {
        step === 0 && !isFinish && <div>
            <div className={"mt-3 font-bold"}>{testingName}</div>
            <div className={'mt-3'}>{testingDescription}</div>
            <div className={'mt-3 flex justify-end'}>
                <Button onClick={onClose} className={'mr-3'}>Отменить</Button>
                <Button onClick={() => onStep(1)} type={'primary'}>
                    {
                        isContinue ? 'Продолжить тест' : 'Запустить тест'
                    }
                </Button>
            </div>
        </div>
    }
            {
                step > 0 && !isFinish && dataItem &&
                <div>
                    <div className={"mt-3 font-bold"}>{testingName}</div>
                    <div className={'mt-3'}>
                        <div>Вопрос {step} из {dataItem?.questions.length}</div>
                        <Progress percent={progress} showInfo={false}/>
                    </div>
                    <div className={'mt-1'}>
                        <div>Время прохождения теста: {timer}</div>
                        <Progress percent={progressTimer} status="exception" showInfo={false}/>
                    </div>
                    <div className={'mt-1 flex flex-wrap gap-2'}>
                        {
                            dataItem?.is_exam !== true && dataItem?.questions.map((questionItem,i) =>
                                <div key={i} onClick={() => onSelectStep(i + 1)} className={'h-6 w-6 flex items-center justify-center cursor-pointer rounded-full ' +
                                    (
                                        dataItem.step_current === i+1 ? 'bg-primary text-white' :
                                            (questionItem.is_answered ?
                                                (questionItem.is_correct ? 'bg-success text-white' : 'bg-error text-white')
                                                : 'bg-slate-300')
                                    )
                                }>{i+1}</div>
                            )
                        }
                    </div>

                        <div style={{minHeight: contentHeight, height: contentHeight, fontSize: '16px'}}
                             className={'flex flex-wrap items-center justify-center mt-6 exam-testing__question'}>
                            <div className={'w-full flex justify-center items-center'} style={{height: '100%'}}>
                                {
                                    dataItem.question.image &&
                                    <img style={{maxHeight: '100%', maxWidth: '100%'}} src={dataItem.question.image}/>
                                }
                                {
                                    !dataItem.question.image && <div>{dataItem.question.text}</div>
                                }
                            </div>
                        </div>
                    {
                        dataItem.question.image && <div className={'text-center mt-3'}>
                            {dataItem.question.text}
                        </div>
                    }
                    {
                        dataItem.question.is_multiple && <div className={'text-center mt-3 font-bold'}>
                            Может быть несколько правильных ответов
                        </div>
                    }

                    <div className={'flex flex-wrap mt-6 justify-center gap-3 exam-testing__answers'}>
                        {
                            dataItem.question.answers.map((answer, index) =>
                                    <Button
                                        key={index} onClick={() => dataItem.question.is_answered ? console.log('ans') : onClickAnswer(answer.id)}
                                        className={'w-3/12 h-auto'}
                                        color={'primary'} variant={userAnswers.includes(answer.id) || answer.is_answered ? 'solid' : 'outlined'}>
                                        {
                                            (userAnswers.includes(answer.id) || answer.is_answered) && <CheckedCircleIcon style={{width: '24px'}}/>
                                        }
                                        {answer.text}
                                    </Button>)
                            }
                        </div>
                        <div className={'flex flex-wrap mt-6 justify-center gap-3 py-3 exam-testing__events'}
                             style={{background: '#f8fafc', borderTop: '1px solid #e9eef5'}}>
                            { dataItem.step_prev > 0 &&
                                <Button onClick={() => onSelectStep(dataItem.step_prev)} className={'w-3/12 h-14'} color='default' variant="filled">
                                <ArrowIcon style={{width: '24px', transform: 'rotate(-90deg)'}}/>
                                Предыдущий вопрос
                            </Button>
                            }
                            {   dataItem.step_next > 0 && dataItem.questions.length >= dataItem.step_next &&
                                <Button onClick={() => onSelectStep(dataItem.step_next)} className={'w-3/12 h-14'} color={'default'} variant={'outlined'}>
                                    {
                                        dataItem.question.is_answered ? 'Далее' : 'Пропустить'
                                    }
                                    <ArrowIcon style={{width: '24px', transform: 'rotate(90deg)'}}/>
                                </Button>
                            }
                            {   dataItem.step_next > 0 && !dataItem.question.is_answered &&
                                <div onClick={() => onConfirmStep(dataItem.step_next)} style={{borderRadius: '6px'}}
                                     className={'w-3/12 h-14 cursor-pointer flex bg-success hover:bg-success-focus text-white align-center items-center text-center justify-center'}>
                                    Подтвердить ответ
                                    <ArrowIcon style={{width: '24px', transform: 'rotate(90deg)'}}/>
                                </div>
                            }
                        </div>
                </div>
            }
        {
            isFinish && resultFinish &&
            <div>
                <div className={'flex mob-block'}>
                    <div className={'w-6/12 mob-w-full'}>
                        <div className={"mt-3 font-bold"}>{testingName}</div>
                        <div className={"mt-3 font-bold"}>{resultFinish.client.fullname}</div>
                        <div className={"font-bold"}>Результаты тестирования</div>
                        <div>Дата прохождения тестирования: {resultFinish.dt}</div>
                        <div>Результат теста: {resultFinish.is_success ? <span style={{color: 'green'}}>Успешно</span> :
                            <span style={{color: 'red'}}>Не успешно</span>}</div>
                        {
                            (!resultFinish.is_exam || resultFinish.is_success) &&
                            <div>Процент правильных ответов {resultFinish.progress_prc}% вопросов
                                ({resultFinish.answers_success} / {resultFinish.questions_total})</div>
                        }
                        {
                            (resultFinish.is_grade && resultFinish.grades) &&
                            <div>
                                Оценка: {
                                resultFinish.grades && resultFinish.answers_success  >= resultFinish.grades.grade5 ? <span style={{color: 'green'}}>Отлично</span> :
                                    resultFinish.grades && resultFinish.answers_success  >= resultFinish.grades.grade4 ? <span style={{color: 'green'}}>Хорошо</span> :
                                        resultFinish.grades && resultFinish.answers_success  >= resultFinish.grades.grade3 ? <span style={{color: 'blue'}}>Удовлетворительно</span> :
                                            <span style={{color: 'red'}}>Не удовлетворительно</span>
                            }
                            </div>
                        }
                        <div>Затраченное время: {resultFinish.time}</div>
                    </div>
                    <div className={'w-6/12 mob-w-full pt-3'}>
                        {
                            resultFinish.is_exam && resultFinish.is_success && <div dangerouslySetInnerHTML={{ __html: resultFinish.information }}></div>
                        }
                    </div>
                </div>
                {
                    (!resultFinish.is_exam || resultFinish.is_success) &&
                    <div className={'mt-3'}>
                        <div
                            className={'is-scrollbar-hidden min-w-full overflow-x-auto rounded-lg border border-slate-200 dark:border-navy-500'}>
                            <table className="w-full text-left exam-testing__table-result">
                                <thead>
                                <tr>
                                    <th className="whitespace-nowrap border border-t-0 border-l-0 border-slate-200 px-3 py-3 font-semibold uppercase text-slate-800 dark:border-navy-500 dark:text-navy-100 lg:px-5">
                                        #
                                    </th>
                                    <th className="border border-t-0 border-slate-200 px-3 py-3 font-semibold uppercase text-slate-800 dark:border-navy-500 dark:text-navy-100 lg:px-5">
                                        Вопрос
                                    </th>
                                    <th className="border border-t-0 border-slate-200 px-3 py-3 font-semibold uppercase text-slate-800 dark:border-navy-500 dark:text-navy-100 lg:px-5" style={{minWidth: '210px'}}>
                                        Правильные ответы
                                    </th>
                                    <th className="border border-t-0 border-slate-200 px-3 py-3 font-semibold uppercase text-slate-800 dark:border-navy-500 dark:text-navy-100 lg:px-5">
                                        Ответы
                                    </th>
                                    <th className="whitespace-nowrap border border-t-0 border-slate-200 px-3 py-3 font-semibold uppercase text-slate-800 dark:border-navy-500 dark:text-navy-100 lg:px-5">
                                        Результат
                                    </th>
                                    <th className="whitespace-nowrap border border-t-0 border-r-0 border-slate-200 px-3 py-3 font-semibold uppercase text-slate-800 dark:border-navy-500 dark:text-navy-100 lg:px-5">
                                        Затраченное время
                                    </th>
                                    {
                                        resultFinish.is_show_info &&
                                        <th style={{minWidth: '210px'}} className="border border-t-0 border-slate-200 px-3 py-3 font-semibold uppercase text-slate-800 dark:border-navy-500 dark:text-navy-100 lg:px-5">
                                            Нормативная документация
                                        </th>
                                    }
                                </tr>
                                </thead>
                                <tbody>
                                {
                                    resultFinish.answers.map((answer, index) => {
                                        return <tr key={index}>
                                            <td className="whitespace-nowrap border border-l-0 border-slate-200 px-3 py-3 dark:border-navy-500 lg:px-5 mob-grey">
                                                <span className={'desktop-hidden font-bold'}>Вопрос #</span>{index + 1}
                                            </td>
                                            <td className="border border-slate-200 px-3 py-3 dark:border-navy-500 lg:px-5">
                                                <div className={'desktop-hidden font-bold'}>Вопрос: </div>{answer.text}
                                            </td>
                                            <td className="border border-slate-200 px-3 py-3 dark:border-navy-500 lg:px-5" style={{minWidth: '210px'}}>
                                                <div className={'desktop-hidden font-bold'}>Правильные ответы: </div>{
                                                answer.correct_answer && answer.correct_answer.map((correctAnswer, key) =>
                                                    <div key={key}>{correctAnswer}</div>)
                                            }
                                            </td>
                                            <td className="border border-slate-200 px-3 py-3 dark:border-navy-500 lg:px-5">
                                                <div className={'desktop-hidden font-bold'}>Ответы: </div>{
                                                answer.user_answer && answer.user_answer.map((userAnswer, key) =>
                                                    <div key={key}>{userAnswer}</div>)
                                            }
                                            </td>
                                            <td className="whitespace-nowrap border border-slate-200 px-3 py-3 dark:border-navy-500 lg:px-5">
                                                <span className={'desktop-hidden font-bold'}>Результат: </span>{answer.is_success ?
                                                <span style={{color: 'green'}}>Успешно</span> :
                                                <span style={{color: 'red'}}>Не успешно</span>}
                                            </td>
                                            <td className="whitespace-nowrap border border-r-0 border-slate-200 px-3 py-3 dark:border-navy-500 lg:px-5">
                                                <span className={'desktop-hidden font-bold'}>Затраченное время: </span>{answer.time}
                                            </td>
                                            {
                                                resultFinish.is_show_info &&
                                                <td className="border border-slate-200 px-3 py-3 dark:border-navy-500 lg:px-5">
                                                    <div className={'desktop-hidden font-bold'}>Нормативная документация:</div>
                                                    <div>{answer.info}</div>
                                                </td>
                                            }
                                        </tr>
                                    })
                                }

                                </tbody>
                            </table>
                        </div>
                    </div>
                }
            </div>
        }
    </div>

}

export default ExamTesting;
